"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Node_privateKey, _Node_publicKey;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Node = void 0;
const ed25519_1 = require("@noble/curves/ed25519");
const bip32crypto = __importStar(require("bip32/src/crypto"));
const Core = __importStar(require("../../core"));
const types_1 = require("../../types");
const revocable_1 = require("./revocable");
class Node extends (0, revocable_1.Revocable)(class {
}) {
    constructor(privateKey, chainCode) {
        super();
        _Node_privateKey.set(this, void 0);
        _Node_publicKey.set(this, void 0);
        if (privateKey.length !== 32)
            throw new Error("bad private key length");
        __classPrivateFieldSet(this, _Node_privateKey, (0, types_1.safeBufferFrom)(privateKey), "f");
        this.addRevoker(() => __classPrivateFieldGet(this, _Node_privateKey, "f").fill(0));
        this.chainCode = (0, types_1.safeBufferFrom)((0, types_1.checkType)(Core.BIP32.ChainCode, chainCode));
    }
    static create(privateKey, chainCode) {
        return __awaiter(this, void 0, void 0, function* () {
            const obj = new Node(privateKey, chainCode);
            return (0, revocable_1.revocable)(obj, (x) => obj.addRevoker(x));
        });
    }
    getPublicKey() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            __classPrivateFieldSet(this, _Node_publicKey, (_a = __classPrivateFieldGet(this, _Node_publicKey, "f")) !== null && _a !== void 0 ? _a : ed25519_1.ed25519.getPublicKey(__classPrivateFieldGet(this, _Node_privateKey, "f")), "f");
            return __classPrivateFieldGet(this, _Node_publicKey, "f");
        });
    }
    sign(message) {
        return __awaiter(this, void 0, void 0, function* () {
            return ed25519_1.ed25519.sign(message, __classPrivateFieldGet(this, _Node_privateKey, "f"));
        });
    }
    derive(index) {
        return __awaiter(this, void 0, void 0, function* () {
            if (index < 0x80000000)
                throw new Error(`Ed25519 requires index ${index} to be hardened`);
            const serP = Buffer.alloc(37);
            serP.set(__classPrivateFieldGet(this, _Node_privateKey, "f"), 1);
            serP.writeUInt32BE(index, 33);
            const I = bip32crypto.hmacSHA512(this.chainCode, serP);
            const IL = I.subarray(0, 32);
            const IR = I.subarray(32);
            const out = yield Node.create(IL, IR);
            this.addRevoker(() => { var _a; return (_a = out.revoke) === null || _a === void 0 ? void 0 : _a.call(out); });
            return out;
        });
    }
}
exports.Node = Node;
_Node_privateKey = new WeakMap(), _Node_publicKey = new WeakMap();
//# sourceMappingURL=ed25519.js.map